import PropTypes from 'prop-types'

export default PropTypes.objectOf(PropTypes.number.isRequired)
